import axios from "axios";

export const API = "/wp-json/maxichoix/v1";

const client = axios.create({ baseURL: API });

export const getCategories = () => client.get("/categories").then((r) => r.data);
export const getProducts = (params = {}) =>
  client.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);
export const getRelated = (slug) =>
  client.get(`/products/${slug}/related`).then((r) => r.data);
export const getReviews = (slug) => client.get(`/reviews/${slug}`).then((r) => r.data);
export const postReview = (data) => client.post("/reviews", data).then((r) => r.data);
export const createOrder = (data) => client.post("/orders", data).then((r) => r.data);
export const sendContact = (data) => client.post("/contact", data).then((r) => r.data);

export default client;
